import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import GQLApplications from "./Applications.graphql";
import GQLDeleteApplication from "./DeleteApplication.graphql";

export default function useDeleteApplication(domain: string) {
    return useMutation<void>(
        gql(GQLDeleteApplication),
        {
            refetchQueries: [
                gql(GQLApplications),
            ],
            variables: {
                domain,
            },
        },
    );
}
